import Provider from "./new/provider";
import Model from "../models/model";

export default class PublishedMappingProvider<T extends Model> extends Provider<T> {
}